export const IMAGE_RESOLUTIONS = ['1K', '2K', '4K'];
